import React, { useEffect } from "react";
import logo from "../assets/img/logo.svg";
import ylw_tick from "../assets/img/ylw_tick.svg";
import next_arrow from "../assets/img/next_arrow.svg";

const Step1 = ({ setStep, setFormdata,formData,setStep1Status }) => {

  const Next=()=>{
    if(formData.open_to_referral){
      setStep1Status(true)
      setStep(2)
    }else{
      setStep(11)
    }
  
  }

  const NoCall=()=>{
    setFormdata((prevState) => ({
      ...prevState, // Keep all other fields the same
      open_to_referral: false, // Update the name field
    }))
    setStep(11)
  }

  useEffect(()=>{
    setFormdata((prevState) => ({
      ...prevState, // Keep all other fields the same
      open_to_referral: true, // Update the name field
    }))
  },[])

  return (
    <>
      {/* <section class="step_wrapper"> */}
        <div class="top_logo_block">
          <div class="logo">
            <a href="">
              <img src={logo} alt="" />
            </a>
          </div>
        </div>

        <div class="step_body">
          <div class="step_form">
            <div class="form_block box_width_lg_one">
              <h1>Are you open to more referrals?</h1>
              <div class="chk_items">
                <div
                  class="item"
                  onClick={() =>
                    setFormdata((prevState) => ({
                      ...prevState, // Keep all other fields the same
                      open_to_referral: true, // Update the name field
                    }))
                  }
                >
                  <input type="radio" name="referral" checked={formData?.open_to_referral} />
                  <div class="check_ui">
                    <img src={ylw_tick} alt="" />
                    <span>Yes</span>
                  </div>
                </div>
                
                <div class="item" onClick={() =>
                    NoCall()
                  }>
                  <input type="radio" name="referral" checked={!formData?.open_to_referral}/>
                  <div class="check_ui">
                    <img src={ylw_tick} />
                    <span>No</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn_block">
              <a onClick={() => Next()} class="nxt_btn">
                {" "}
                <span>next</span> <img src={next_arrow} />
              </a>
            </div>
          </div>
        </div>

        {/* <div class="bottom_steps">
          <ul class="for_desktop">
            <li onClick={()=>setStep(1)} class="active">
              <span>Referrals</span>
            </li>
            <li onClick={()=>setStep(2)}>
              <span>Your details</span>
            </li>
            <li onClick={()=>setStep(3)}>
              <span>Profession</span>
            </li>
            <li onClick={()=>setStep(4)}>
              <span>Ideal Client</span>
            </li>
            <li onClick={()=>setStep(5)}>
              <span>Good referral partners</span>
            </li>
            <li onClick={()=>setStep(6)}>
              <span>Date of birth</span>
            </li>
            <li onClick={()=>setStep(7)}>
              <span>Communication channel</span>
            </li>
            <li onClick={()=>setStep(8)}>
              <span>Hobbies</span>
            </li>
            <li onClick={()=>setStep(9)}>
              <span>Submit</span>
            </li>
          </ul>
          <div class="step_for_mob">
            <p>
              <span>1</span> of 9
            </p>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default Step1;
